import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";


const LeadsOrganizationLayout = () => {
    const navList = useNav();
  let { LeadsOrgBottomHeader, LeadsTopHeader } = navList;
    return (
        <div className="webBody">
            <Header bottomTabs={LeadsOrgBottomHeader} topTabs={LeadsTopHeader} />
            <Outlet />
        </div>
    )
}

export default LeadsOrganizationLayout;